<template>
  <div data-testid="statement-filters-loader">
    <SkeletonLoader class="filters-loader" show-animation>
      <div class="filters-loader__type" />
      <div class="filters-loader__period" />
      <div class="filters-loader__module" />
      <div class="filters-loader__export" />
    </SkeletonLoader>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  components: { SkeletonLoader }
})
export default class StatementFiltersLoader extends Vue {}
</script>

<style lang="less" scoped>
.filters-loader {
  display: flex;
  &__type {
    width: 147px;
    height: 30px;
    margin-right: @size-spacing-x300;
    border-radius: @size-radius-x400;
  }
  &__period {
    width: 100px;
    height: 30px;
    margin-right: @size-spacing-x300;
    border-radius: @size-radius-x400;
  }
  &__module {
    width: 80px;
    height: 30px;
    margin-right: @size-spacing-x300;
    border-radius: @size-radius-x400;
  }
  &__export {
    width: 123px;
    height: 30px;
    border-radius: @size-radius-x200;
  }
}
</style>
